<div
    class="marketing-banner">
    <div class="container">
        <div class="marketing-banner-container">
            <div class="marketing-banner-container-section">
                <h1 class="policy-title">{{ policyTitle }}</h1>
                <p class="policy-info">{{ policyInfo }}</p>
                <div class="buttonlink">
                    <button
                    class="get-quote-btn"
                    (click) = "navigate(buttoninfo.buttonURL,buttoninfo.buttonName)"
                    > {{buttoninfo.buttonName}}</button>
                   </div>
            </div>
            <div class="marketing-banner-container-section">
                <img class="rightimage" src= {{imageBasePath+imagePath}} alt={{policyTitle}} />
            </div>
        </div>
    </div>
</div>
